// extracted by mini-css-extract-plugin
export default {"title":"Data_title__PX+--"};